import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("lm_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiError(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Errore imprevisto";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((x) => (x && x.msg) || JSON.stringify(x)).join(" ");
  return String(detail);
}

export function imgUrl(image) {
  if (!image) return "";
  if (image.startsWith("http")) return image;
  return `${process.env.REACT_APP_BACKEND_URL}/api/files/${image}`;
}

export default api;
